module.exports = __webpack_public_path__ + "img/budget-topten.8e82202f.png";